export const ENDPOINTS = {
  AUTHORIZE: "/authorize",
  TOKEN: "/token",
  CREDENTIALS: "/credentials",
  RETRY: "/purchase/retry",
  OUTCOME: "/session/outcome",
  REJECT: "/purchase/reject",
};

export const MESSAGES = {
  TEST_MODE:
    "All transactions are simulated and no payments will be processed.",
  ADMIN:
    "You have succesfully configured the shop. Please disable test mode to start accepting real transactions.",
};
